import { role as types } from '../../constants/types'
const role = {
    roles: [],
    role: {},
    loading: false,
    error: null
}
const reducer = (state = role, action) => {
    const data = action.payload;
    const roles = state.roles;
    const indexOfRole = (types.PUT || types.DELETE) ? roles.findIndex(obj => obj.id === data?.id) : 0;
    switch (action.type) {
        case types.GET: return { ...state, roles: data };
        case types.ROLE: return { ...state, role: data };
        case types.PUSH: return { ...state, role: data, roles: [...roles, data] };
        case types.PUT: {
            roles[indexOfRole] = data;
            return { ...state, role: data, roles: roles };
        }
        case types.DELETE: {
            roles.splice(indexOfRole, 1);
            return { ...state, role: data, roles: roles };
        }
        case types.LOADING: return { ...state, loading: !state.loading };
        case types.ERROR: return { ...state, error: data };
        default: return state;
    }
};
export default reducer